import LeilaoMixin from '../../comunicator_wrapper/src/integrations/vue/mixins/leilao.mixin.js'
// import LeilaoMixin from 'comunicator/src/integrations/vue/mixins/leilao.mixin.js'


export default LeilaoMixin
